import { render, staticRenderFns } from "./DashFooter.vue?vue&type=template&id=f0eda9d8&scoped=true&"
var script = {}
import style0 from "./DashFooter.vue?vue&type=style&index=0&id=f0eda9d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0eda9d8",
  null
  
)

export default component.exports